<template>
	 <div class="dynamiclist qualityenterprise"> 
				 <leftnav class="fl" mkcode="b" itemcode="A-QYTZDT"></leftnav>
				<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''"> 
					<govheader></govheader>
					<div class="index_left_centerpage">
						<div class="whitebox right_topbox" style="padding-bottom: 1px;">
							<div class="right_boxtitle">
								<span class="fl right_title">动态监测</span> 
							</div> 
					 <div class="opport-screen-list1"> 
					 	 <ClueNav :searchtype="searchtype" ></ClueNav>
						<dl class="opport-screen bdbe">
							<dt class="fl">时间</dt>
							<dd class="fl">
								<span v-for="(item,index) in dayarry" @click="daychoose(item.key);" :class="timekey == item.key?'a-screen current':'a-screen'">{{item.name}}</span>
							</dd>
						</dl> 
						<dl class="opport-screen bdbe">
							<dt class="fl titleop">动态类型</dt>
							<dd class="fl">
							 <span :class="dynamictype == 1 ?'a-screen current':'a-screen'" @click="dynamictypeToggle(1)" >全部动态</span>
								<span :class="dynamictype == 2 ?'a-screen current':'a-screen'" @click="dynamictypeToggle(2)">关注的企业动态</span>
							</dd>
						</dl>
						<div class="eninvest_list_screen oh" v-show="dynamictype==2">
							<h5 class="fl title">企业名称</h5>
							<div class="fl">
								<el-select v-model="stockChiness" placeholder="全部" @change="getEnterpriseName"><el-option  v-for="item in enterpriseOption"  :key="item.id"  :label="item.title"   :value="item.title"> </el-option> </el-select>
							</div>
							<span class="basebtn"@click="routerlinkid('/enterpirseinvestEdit')">添加企业</span>
						</div>
					</div>
				</div>
				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" >产业大脑为您找到<span class="searchnum">{{total}}</span>条匹配的企业资讯动态</p> 
					</div>
					<div class="information_content information_box">
						<div class="infornews" v-for="list in newslistdata" >
							<div @click="routerlinkid('/informationdetail',list.id,2)" class="infornews_d">
								<h5 class="title"><span class="fl info_title">{{list.title}}</span><span class="fr">{{list.publishTime}}</span></h5> 
							</div>  
							<div class="keywords"  >
								<span   @click="routerlinkid('/enterprises',list.stockCode, )">{{list.enterpriseName}}</span>
							</div>
						</div> 
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div> 
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'enterpriseNews',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data: function(){
			return{
		  userdata:{},	title: '企业资讯动态',
				searchtype:5,  dynamictype:1,
				enterinarr: [
					{curindex: 1,type: 9,name: "投资项目动态",tagnum:10010,url:"/investdynamic"},
					{curindex: 2,type: 1,name: "拿地项目动态",tagnum:10010,url:"/landdynamic"},
					{curindex: 3,type: 2,name: "企业资讯动态",tagnum:3,url:"/enterpriseNews"}, 
					{curindex: 4,type: 3,name: "招商情报动态",tagnum:10009,url:"/timeinfor"},   
				],
				enterpriseOption:[],
				dayarry:[{name:"本月",key:"month"},{name:'本周',key:"week"},{name:"本日",key:"day"}],
				stockChiness:'全部', searchstockCode:'',
				timekey:'month', 
				newslistdata:[], 
					page: 1, //显示的是哪一页
					pageSize: 10, //每一页显示的数据条数
					total: 0, //记录总数
					totalPage: 1,
					maxPage: 10, //最大页数 
			};
		},
		created() { 
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
				this.userdata = this.getuseriformation();
				
				// this.bus.$emit('loading', true);
		},
	 
		mounted() {
		// this.gethotindustry(); 
		if(this.userdata.edition<1){
			var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function(){
				_this.routerself('/totalEnterprises');
			},1000)
			return;
		}
		// this.bus.$emit('loading', true);
		this.getenterOption();
		this.getdynamiclist();
		},
		methods:{
			//全部动态和企业全部动态筛选
			dynamictypeToggle(type){
				this.dynamictype=type;
				this.searchstockCode=type == 1?'':'all'; 
				this.getdynamiclist();
			},
			//时间筛选
			daychoose(key){
				this.timekey=key;
				this.getdynamiclist();
			}, 
			//获取用户设置的企业列表数据
			getenterOption(){ 
				var _this=this;
				var ajaxurl=this.$api.cyl.enterprisenews.list();
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log(ajaxurl)
					console.log('获取用户设置的企业列表数据',res.data.list)
					if (res.data.success) {
						_this.enterpriseOption=res.data.list; 
						_this.enterpriseOption.unshift({id:0,title:'全部',stockCode:"all"})
					} else {
						_this.tokenfailed(res.data.msg);
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//点击设置当前搜索名字
			getEnterpriseName(val){
				console.log(val);
				var _this=this;
				this.enterpriseOption.forEach(list=>{
					if(list.title == val){
						_this.searchstockCode=list.stockCode;
						_this.getdynamiclist();
						return;
					}
				})
			},
		//获取动态列表
		getdynamiclist(page){
			this.bus.$emit('loading', true);
			if(!page){
				page=1;this.page=1;
			}  
		 
			var stockja =this.splicing('stockCode',this.searchstockCode);
			var pageja =this.splicing('page',this.page);
			var _this=this;
			var ajaxurl=this.$api.cyl.enterprisenews.list()+'?date='+_this.timekey+stockja+pageja;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function(res) {
				console.log(ajaxurl)
				console.log('获取企业资讯列表',res.data)
				if (res.data.success) {
					_this.newslistdata=res.data.list;
					 // _this.bus.$emit('loading', false);
					 _this.totalPage = res.data.totalPage;
					 _this.pageSize = res.data.pageSize;
					 _this.total = res.data.totalRecord; 
					_this.bus.$emit('loading', false); 
				} else {
					_this.tokenfailed(res.data.msg);
				}
			}).catch(function(error) {
				// 请求失败处理 console.log(error);
			});
		},
		//搜索关键词
		searchkwfun() {
			this.searchtext = $.trim(this.searchtext);
			// if(this.searchtext!="" || ){
			this.getdynamiclist();
			// } 
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
		pageHandler: function(page) {
			this.page = page;
			this.getdynamiclist(page);
		}, 
		}
	}
</script>

<style>
	.a-red{
		color:#c00;
	}
	.right_boxtitle .el-tooltip{
		position: relative;top: 10px;
	}
</style>